module.exports = __webpack_public_path__ + "img/2021.55fef553.jpg";